/**
 * @module custom-elements
 * @description Global Vue Configuration. Register all custom elements and load
 * them by async-imports as chunks to keep initial script size as small as
 * possible.
 *
 * Note 2018-11: We still use VueCustomElement until we can savely drop support
 * for IE11 which is not supported by the native Vue-Web-Component-Wrapper OR if
 * VWCW will one day supports IE11, see:
 * https://github.com/vuejs/vue-web-component-wrapper/issues/31
 */
import 'intersection-observer'
import installCE from 'document-register-element/pony'
import Vue from 'vue'
import VueCustomElement from 'vue-custom-element'
import Vuelidate from 'vuelidate'
import '@oeamtc/lib-ui/lib/lib-ui.css'
import '@mein-oeamtc/lib-auth/lib/lib-auth.css'
import '@mein-oeamtc/lib-ui/lib/lib-ui.css'

installCE(global, 'auto')

Vue.config.productionTip = false

Vue.use(VueCustomElement)
Vue.use(Vuelidate)

Vue.customElement('poi-map-component', () => {
  return import(/* webpackChunkName: "poi-map-component" */ './components/PoiMapComponent')
    .then(m => m.default)
})

Vue.customElement('personalisation-overlay-component', () => {
  return import(/* webpackChunkName: "personalisation-overlay-component" */ './components/PersonalisationOverlayComponent')
    .then(m => m.default)
})

Vue.customElement('star-rating-component', () => {
  return import(/* webpackChunkName: "star-rating-component" */ './components/StarRatingComponent')
    .then(m => m.default)
})

Vue.customElement('nova-calculator-component', () => {
  return import(/* webpackChunkName: "nova-calculator-component" */ './components/NovaCalculatorComponent')
    .then(m => m.default)
})

Vue.customElement('vehicle-related-tax-calculator-component', () => {
  return import(/* webpackChunkName: "vehicle-related-tax-calculator-component" */ './components/VehicleRelatedTaxCalculatorComponent')
    .then(m => m.default)
})

Vue.customElement('shop-product-detail-cta-component', () => {
  return import(/* webpackChunkName: "shop-product-detail-cta-component" */ './components/ShopProductDetailCTAComponent')
    .then(m => m.default)
})

Vue.customElement('shop-shopping-cart-cta-component', () => {
  return import(/* webpackChunkName: "shop-shopping-cart-cta-component" */ './components/ShopShoppingCartCTAComponent')
    .then(m => m.default)
})

Vue.customElement('shop-inquiry-and-consultation-process-component', () => {
  return import(/* webpackChunkName: "shop-inquiry-and-consultation-process-component" */ './components/ShopInquiryAndConsultationProcessComponent')
    .then(m => m.default)
})

Vue.customElement('shop-order-process-component', () => {
  return import(/* webpackChunkName: "shop-order-process-component" */ './components/ShopOrderProcessComponent')
    .then(m => m.default)
})

Vue.customElement('location-index-input-component', () => {
  return import(/* webpackChunkName: "location-index-input-component" */ './components/LocationIndexInputComponent')
    .then(m => m.default)
})

Vue.customElement('routeplanner-widget-component', () => {
  return import(/* webpackChunkName: "routeplanner-widget-component" */ './components/RouteplannerWidgetComponent')
    .then(m => m.default)
})

Vue.customElement('fuelprice-widget-component', () => {
  return import(/* webpackChunkName: "fuelprice-widget-component" */ './components/FuelpriceWidgetComponent')
    .then(m => m.default)
})

Vue.customElement('tripradar-widget-component', () => {
  return import(/* webpackChunkName: "tripradar-widget-component" */ './components/TripradarWidgetComponent')
    .then(m => m.default)
})

Vue.filter('formatCurrency', (number) => {
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(number.toString().replace(/,/g, ''))
})
